class FJAnimationTimelineData {
    constructor(props = {}) {
        const { startTime = 0, endTime = 0, duration = 0 } = props;
        this._startTime = startTime;
        this._endTime = endTime;
        this._animationTimes = [];
    }

    get startTime() {
        return this._startTime;
    }
    get endTime() {
        return this._endTime;
    }
    get animationTimes() {
        return this._animationTimes;
    }

    addTimeData(data) {
        this._animationTimes.push(data);
    }
    getTimeDataInTime(time) {
        return this._animationTimes.find(item => item.startTime <= time && item.endTime >= time);
    }
    getTimeDataByAnimationName(animationName) {
        return this._animationTimes.find(item => item.animationName === animationName);
    }
}

export default FJAnimationTimelineData;
